// @flow

export { InputColombianDocument } from './input-colombian-document';
export { InputColombianDocumentType } from './input-colombian-document-type';
export { InputColombianPhoneNumber } from './input-colombian-phone-number';
export { InputColombianZipcode } from './input-colombian-zipcode';
export { InputColombianAddress } from './input-colombian-address';
